import { Card } from "@amzn/stencil-react-components/card";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { H3, Text } from "@amzn/stencil-react-components/text";
import React from "react";
import { StatusEnum } from "../../hoc/with-status";
import useArb from "../../hooks/use-arb";
import { renderBGColor } from "../task/ui-redesign";

export interface Props {
  status: StatusEnum;
  descriptionText: string;
  image: JSX.Element;
}

type UseStatusTextType = (text: string | undefined) => string;

export const bgcUseStatusText: UseStatusTextType = (text) => {
  const safeString = (text?.toString() as keyof typeof cases) || "";
  const { getMessage } = useArb("HVHChecklistPantherResource");

  const cases = {
    [StatusEnum.AWAITING_CANDIDATE_INFO]: () => getMessage("checklist-General-BGCInformation-Pending"),
    [StatusEnum.ERROR]: () => getMessage("checklist-General-TaskStatus-Error"),
    [StatusEnum.COMPLETED]: () => getMessage("checklist-General-TaskStatus-Completed"),
    [StatusEnum.IN_PROGRESS]: () => getMessage("checklist-General-TaskStatus-InProgress"),
    [StatusEnum.INITIATED]: () => getMessage("checklist-General-TaskStatus-InProgress"),
    [StatusEnum.NOT_REQUIRED]: () => getMessage("checklist-General-TaskStatus-InProgress"),
  };

  const statusText = typeof cases[safeString] === "function" && cases[safeString]();

  return statusText || safeString;
};

export const FlyOutStatusCard = ({ status, image, descriptionText }: Props) => {
  const bundle = useArb("HVHChecklistPantherResource");

  const translatedStatus = bundle.getMessage("checklist-General-Status");

  return (
    <Col padding="S300" gridGap="S300">
      <Card>
        <Col backgroundColor={renderBGColor(status)} width={"6px"} />
        <Col gridGap="S300" padding="S300" width={"100%"}>
          <H3 fontSize={"T400"}>{translatedStatus}</H3>
          <Row alignItems={"center"} gridGap={"S200"}>
            {image}
            <Text>{descriptionText}</Text>
          </Row>
        </Col>
      </Card>
    </Col>
  );
};
